var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"buttons":['cancel'],"extra-large":"","title":"Atendimentos"}},[(_vm.atendimentosData)?_c('BoxHistorico',{attrs:{"data":_vm.atendimentosData,"hide-historico-v1":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }